import Stack from "@mui/material/Stack";
import React, { useEffect } from "react";
// import MapBox from "../components/dashboard/infoboxes/MapBox";
import InfoBox from "../components/dashboard/infoboxes/InfoBox";
// import { TodayInfoBox } from "../components/dashboard/infoboxes/TodayInfoBox";
// import  from "@mui/material/";
import Box from "@mui/material/Box";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, []);

  return (
    <Box>
      <Stack direction='column' justifyContent='center' spacing={4}>
        <InfoBox
          title='ORDERS'
          total='50'
          lastMonth='0'
          lastWeek='0'
          today='0'
        />

        {/* <>
        <TodayInfoBox />
      </> */}

        <InfoBox
          title='USERS'
          total='52'
          lastMonth='0'
          lastWeek='0'
          today='0'
        />
      </Stack>
    </Box>
  );
};

export default Home;
